import { getPermissions } from "@/helper/collection";

export const MarketingRoutes = {
  path: "marketing",
  name: "Marketing",
  redirect: "marketing/marketing-master",
  component: {
    render(c) {
      return c("router-view");
    }
  },
  children: [
    {
      path: "/",
      name: "",
      component: () =>
        import("@/components/Pages/MarketingContainer/marketingMaster"),
      meta: {}
    },
    {
      path: "promotions-and-offers",
      name: "Promotions And Offers",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/PromotionsAndOffersComponent/promotionsAndOffers.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          109,
          1
        )
      }
    },
    {
      path: "add-promotions-and-offers",
      name: "Add Promotions And Offers",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/PromotionsAndOffersComponent/addPromotionsAndOffers.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          109,
          2
        )
      }
    },
    {
      path: "edit-promotions-and-offers",
      name: "Edit Promotions And Offers",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/PromotionsAndOffersComponent/editPromotionsAndOffers.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          109,
          2
        )
      }
    },
    {
      path: "view-promotions-and-offers",
      name: "View Promotions And Offers",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/PromotionsAndOffersComponent/detailsPromotionsAndOffers.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          109,
          1
        )
      }
    },
    {
      path: "view-usage-promotions-and-offers",
      name: "View Usage Promotions And Offers",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/PromotionsAndOffersComponent/viewUsagePromotionsAndOffers.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "CinemaManager"],
          false,
          "",
          109,
          1
        )
      }
    },
    {
      path: "vouchers",
      name: "Vouchers",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/VouchersComponent/vouchers.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          110,
          1
        )
      }
    },
    {
      path: "add-vouchers",
      name: "Add Vouchers",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/VouchersComponent/addVouchers.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          110,
          2
        )
      }
    },
    {
      path: "edit-vouchers",
      name: "Edit Vouchers",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/VouchersComponent/editVouchers.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          110,
          2
        )
      }
    },
    {
      path: "view-vouchers",
      name: "View Vouchers",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/VouchersComponent/viewVouchers.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          110,
          1
        )
      }
    },
    {
      path: "view-vouchers-codes",
      name: "View Vouchers Codes",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/VouchersComponent/viewVoucherCodes.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          110,
          1
        )
      }
    },
    // view-usage-voucher
    {
      path: "view-usage-voucher",
      name: "View Vouchers Usage",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/VouchersComponent/viewVouchersUsage.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          110,
          1
        ) //change 110
      }
    },
    {
      path: "loyalty",
      name: "Loyalty",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/LoyaltyComponent/loyalty.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          111,
          1
        )
      }
    },
    {
      path: "add-loyalty",
      name: "Add Loyalty",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/LoyaltyComponent/addLoyalty.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          111,
          2
        )
      }
    },
    {
      path: "edit-loyalty",
      name: "Edit Loyalty",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/LoyaltyComponent/editLoyalty.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          111,
          2
        )
      }
    },
    {
      path: "view-loyalty",
      name: "View Loyalty",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/LoyaltyComponent/viewLoyalty.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          111,
          1
        )
      }
    },
    {
      path: "customer-loyalty-points",
      name: "Customer Loyalty Points",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/CustomerLoyaltyPointsComponents/listcustomerloyaltypoints.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          112,
          2
        )
      }
    },
    {
      path: "view-customer-loyalty-points",
      name: "View Customer Loyalty Points",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/CustomerLoyaltyPointsComponents/viewcustomerloyaltypoints.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          112,
          1
        )
      }
    },
    {
      path: "global-loyalty-settings",
      name: "Global Loyalty Settings",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/GlobalLoyaltySettingsComponents/listgloballoyaltysettings.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          113,
          1
        )
      }
    },
    {
      path: "add-global-loyalty-settings",
      name: "Add Global Loyalty Settings",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/GlobalLoyaltySettingsComponents/addgloballoyaltysettings.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          113,
          2
        )
      }
    },
    {
      path: "edit-global-loyalty-settings",
      name: "Edit Global Loyalty Settings",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/GlobalLoyaltySettingsComponents/editgloballoyaltysettings.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          113,
          2
        )
      }
    },
    {
      path: "view-global-loyalty-settings",
      name: "View Global Loyalty Settings",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/GlobalLoyaltySettingsComponents/viewgloballoyaltysettings.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          113,
          1
        )
      }
    },
    {
      path: "cinema-loyalty-settings",
      name: "Loyalty Settings",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/LoyaltySettingsComponents/listcinemaloyaltysettings.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          114,
          1
        )
      }
    },
    {
      path: "add-cinema-loyalty-settings",
      name: "Add Cinema Loyalty Settings",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/LoyaltySettingsComponents/addcinemaloyaltysettings.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          114,
          2
        )
      }
    },
    {
      path: "edit-cinema-loyalty-settings",
      name: "Edit Cinema Loyalty Settings",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/LoyaltySettingsComponents/editcinemaloyaltysettings.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          114,
          2
        )
      }
    },
    {
      path: "view-cinema-loyalty-settings",
      name: "View Cinema Loyalty Settings",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/LoyaltySettingsComponents/viewcinemaloyaltysettings.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          114,
          1
        )
      }
    },
    {
      path: "bank",
      name: "Bank",
      component: () =>
        import("@/components/Pages/MarketingContainer/bankComponents/bank.vue"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          115,
          1
        )
      }
    },
    {
      path: "add-bank",
      name: "Add Bank",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/bankComponents/addBank.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          115,
          2
        )
      }
    },
    {
      path: "edit-bank",
      name: "Edit Bank",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/bankComponents/editBank.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          115,
          2
        )
      }
    },
    {
      path: "view-bank",
      name: "View Bank",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/bankComponents/viewBank.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          115,
          1
        )
      }
    },
    {
      path: "institution",
      name: "View Institutions",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/InstitutionComponents/institution.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          116,
          1
        )
      }
    },
    {
      path: "add-institution",
      name: "Add Institution",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/InstitutionComponents/addInstitution.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          116,
          2
        )
      }
    },
    {
      path: "edit-institution",
      name: "Edit Institution",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/InstitutionComponents/editInstitution"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          116,
          2
        )
      }
    },
    {
      path: "view-institution",
      name: "View Single Institution",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/InstitutionComponents/viewInstitution"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          116,
          1
        )
      }
    },
    {
      path: "offer-types",
      name: "View Offer Types",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/OfferComponents/offerTypes"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          117,
          1
        )
      }
    },
    {
      path: "add-offer-Types",
      name: "Add Offer Types",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/OfferComponents/addOfferTypes"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          117,
          2
        )
      }
    },
    {
      path: "edit-offer-Types",
      name: "Edit Offer Types",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/OfferComponents/editOfferTypes"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          117,
          2
        )
      }
    },
    {
      path: "view-offer-Types",
      name: "View Single Offer Types",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/OfferComponents/viewOfferTypes"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          117,
          1
        )
      }
    },
    {
      path: "bin-Numbers",
      name: "Bin Numbers",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/BinNumbersComponents/binNumbers"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "CinemaManager"],
          false,
          "",
          118,
          1
        )
      }
    },
    {
      path: "add-bin-Numbers",
      name: "Add Bin Numbers",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/BinNumbersComponents/addBinNumbers"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          118,
          2
        )
      }
    },
    {
      path: "edit-bin-Numbers",
      name: "Edit Bin Numbers",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/BinNumbersComponents/editBinNumbers"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          ""
        )
      }
    },
    {
      path: "customers",
      name: "Customers",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/CustomersComponents/customers"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          119,
          1
        )
      }
    },
    {
      path: "add-Customers",
      name: "Add Customers",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/CustomersComponents/addCustomers"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          119,
          2
        )
      }
    },
    {
      path: "edit-Customers",
      name: "Edit Customers",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/CustomersComponents/editCustomers"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          119,
          2
        )
      }
    },
    {
      path: "view-Customers",
      name: "View Customers",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/CustomersComponents/viewCustomers"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          119,
          1
        )
      }
    },
    {
      path: "card-type",
      name: "Card Type",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/CardTypeComponents/cardType"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          120,
          1
        )
      }
    },
    {
      path: "add-card-type",
      name: "Add Card Type",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/CardTypeComponents/addCardType"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          120,
          2
        )
      }
    },
    {
      path: "edit-card-type",
      name: "Edit Card Type",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/CardTypeComponents/editCardType"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          120,
          2
        )
      }
    },
    {
      path: "view-card-type",
      name: "View Card Type",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/CardTypeComponents/viewMarketingCardType"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          120,
          1
        )
      }
    },
    {
      path: "list-pages",
      name: "CMS Pages",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/PageComponents/listPage.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          154,
          1
        )
      }
    },
    // {
    //     path: "add-seo",
    //     name: "Add Seo",
    //     component: () => import("@/components/Pages/MarketingContainer/SeoComponents/addseo.vue"),
    //     meta: {
    //         permissions: getPermissions(['SuperAdmin', 'HoManager', 'CinemaManager'], false, '', 154, 2)
    //     }
    // },
    {
      path: "edit-page/:seo_id",
      name: "Edit CMS Page",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/PageComponents/editPage.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          154,
          2
        )
      }
    },
    {
      path: "view-page/:seo_id",
      name: "View Page",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/PageComponents/viewPage.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          154,
          1
        )
      }
    },
    {
      path: "cash-cards",
      name: "Cash Cards",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/CashCardComponents/cashCards.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          159,
          1
        )
      }
    },
    {
      path: "add-cash-card",
      name: "Add Cash Card",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/CashCardComponents/addCashCard.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          159,
          2
        )
      }
    },
    {
      path: "edit-cash-card/:cash_card_id",
      name: "Edit Cash Card",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/CashCardComponents/editCashCard.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          159,
          2
        )
      }
    },
    {
      path: "list-cash-cards-gallery",
      name: "Cash Card Gallery",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/CashCardGallery/listCashCardGallery.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          159,
          1
        )
      }
    },
    {
      path: "cash-cards-template",
      name: "Website Cash Card",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/CashCardGallery/WebsiteCashCard.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          159,
          2
        )
      }
    },
  ]
};



// WEBPACK FOOTER //
// ./src/router/marketingRoutes.js